<app-dialog-base [Title]='"Violations"|translate' [dialogId]="dialogId" (onClose)="close()" (onSubmit)="submit()">
  <div class="btn_tabs">
    <button (click)="openTab('main')" [class.active]="openedTabName == 'main'">{{"Violations"|translate}}</button>
    <button (click)="openTab('limits')" [class.active]="openedTabName == 'limits'">{{"Rating"|translate}}</button>
  </div>
  <div class="horseparator"></div>

  <!--  ....................................................................................  -->

  <div class="tablewrap" *ngIf="isSelected('main')" id="main">
    <div class="table">
      <table fixedcols="[]">
        <tr>
          <th colspan="2"><label>{{'Violation'|translate}}</label></th>
          <th><label>{{'Penalty'|translate}}</label></th>
          <th><label>{{'Type'|translate}}</label></th>
          <th><label>{{'Min. duration'|translate}}</label></th>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Harsh speed'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.HarshSpeed.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.HarshSpeed.OneTime">
              <option [ngValue]="true">{{'each time'|translate}}</option>
              <option [ngValue]="false">{{'per minute'|translate}}</option>
            </select>
          </td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.HarshSpeed.MinDuration">
              <span>{{'sec'|translate}}</span>
            </label>
          </td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Dangerous speed'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DangerousSpeed.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.DangerousSpeed.OneTime">
              <option [ngValue]="true">{{ 'each time' | translate }}</option>
              <option [ngValue]="false">{{ 'per minute' | translate }}</option>
            </select>
          </td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DangerousSpeed.MinDuration">
              <span>{{'sec'|translate}}</span>
            </label>
          </td>
        </tr>
        <!----------------------------------------------->

        <tr>
          <td colspan="2"><label>{{'Harsh acceleration'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.HarshAccel.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Dangerous acceleration'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DangerousAcceleration.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Harsh breaking'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.HarshBreak.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Dangerous breaking'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DangerousBreak.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Harsh turning'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.HarshTurn.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Dangerous turn'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DangerousTurn.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td></td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Idling'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.Idling.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.Idling.OneTime">
              <option [ngValue]="true">{{ 'each time' | translate }}</option>
              <option [ngValue]="false">{{ 'per minute' | translate }}</option>
            </select>
          </td>
          <td></td>
        </tr>
        <!----------------------------------------------->
        <!-- <tr>
          <td colspan="2"><label>{{'Driving without rest'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DrivingWithoutRest.Penalty">
              <span>{{'points'|translate}}</span>
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.DrivingWithoutRest.OneTime">
              <option [selected]="model.DrivingWithoutRest.OneTime == true" [ngValue]="true">{{'each time'|translate}}</option>
              <option [selected]="!model.DrivingWithoutRest.OneTime != true" [ngValue]="false">{{'per minute'|translate}}</option>
            </select>
          </td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.DrivingWithoutRest.MinDuration">
              <span>{{'sec'|translate}}</span>
            </label>
          </td>
        </tr> -->
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Driving with lights off'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.Lights.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.Lights.OneTime">
              <option [ngValue]="true">{{ 'each time' | translate }}</option>
              <option [ngValue]="false">{{ 'per minute' | translate }}</option>
            </select>
          </td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.Lights.MinDuration">
              <span>{{'sec'|translate}}</span>
            </label>
          </td>
        </tr>
        <!----------------------------------------------->
        <tr>
          <td colspan="2"><label>{{'Driving without seat belt'|translate}}</label></td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.SeatBelt.Penalty">
              <!-- <span>{{'points'|translate}}</span> -->
            </label>
          </td>
          <td>
            <select [(ngModel)]="model.SeatBelt.OneTime">
              <option [ngValue]="true">{{ 'each time' | translate }}</option>
              <option [ngValue]="false">{{ 'per minute' | translate }}</option>
            </select>
          </td>
          <td>
            <label class="speedgroup">
              <input type="number" [(ngModel)]="model.SeatBelt.MinDuration">
              <span>{{'sec'|translate}}</span>
            </label>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <!--  ....................................................................................  -->

  <div id="limits" *ngIf="isSelected('limits')" class="tablewrap">
    <div class="inputgroup">
      <label>{{'Rating calculation depth'|translate}}</label>
      <label>
        <input type="number" [(ngModel)]="model.RatingDepth">
        <span>{{'days'|translate}}</span>
      </label>
    </div>
    <div class="inputgroup">
      <label>{{'Green zone limit'|translate}}</label>
      <label>
        <input type="number" [(ngModel)]="model.GreenZone">
        <span>{{'points'|translate}}</span>
      </label>
    </div>
    <div class="inputgroup">
      <label>{{'Yellow zone limit'|translate}}</label>
      <label>
        <input type="number" [(ngModel)]="model.YellowZone">
        <span>{{'points'|translate}}</span>
      </label>
    </div>
  </div>
</app-dialog-base>